import * as React from 'react';
import { observer } from 'mobx-react';
import cx from 'classnames';

const styles = require('./index.less');

const EmptyText = ({className}) => {
  return <div className={cx(styles.emptyTextRoot,className)}>暂无数据</div>;
};

export default observer(EmptyText);
